import * as React from "react";
import { ChildProps, graphql } from "react-apollo";
import { Button } from "@material-ui/core";
import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import { TicketEvent, REVIEWABLE_STATUSES } from "./ticketEventTypes";
import {
  BottomBackBar,
  TicketEventActionsSection,
  TicketEventBrandingSection,
  TicketEventDetailsSection,
  TicketEventReviewSection,
  TicketEventSummaryHeader,
  TicketEventTicketOptionsSection,
} from "./ticketEventSummaryHelpers";
import { ticketEventsSummaryQuery } from "./ticketEventsSummaryQuery";

type GqlData = {
  ticket_events: Array<TicketEvent>;
};

type Props = ChildProps<
  {
    id: string;
    setHeader: (args: { title: string; description: string }) => void;
    history: any;
    backPath: string;
  },
  GqlData
>;

class TicketEventContainer extends React.Component<Props> {
  componentDidMount() {
    this.props.setHeader({
      title: "Events > Summary",
      description: "Review and action an event",
    });
  }

  reloadData = () => {
    this.props.data.refetch();
  };

  isActionable(status?: string) {
    return REVIEWABLE_STATUSES.includes(status);
  }

  render() {
    return (
      <BOGraphQLLoader data={this.props.data}>
        {(() => {
          const ticketEvents = this.props.data.ticket_events || [];
          const ticketEvent = ticketEvents.find(
            (event) => String(event.id) === String(this.props.id)
          );

          if (!ticketEvent) {
            return (
              <section className="padded">
                <div
                  style={{
                    height: "calc(100vh - 120px)",
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "#fff",
                      padding: "20px",
                      border: "1px solid #d7d7d7",
                    }}
                  >
                    Event not found.
                  </div>

                  <Button
                    style={{ marginTop: "15px" }}
                    onClick={() => this.props.history.push(this.props.backPath)}
                  >
                    Back
                  </Button>
                </div>
              </section>
            );
          }

          const showActions = this.isActionable(ticketEvent.status);
          const redirectPath = this.props.backPath;

          return (
            <section className="padded">
              <div
                style={{
                  height: "calc(100vh - 120px)",
                  overflowY: "auto",
                  overflowX: "hidden",
                  paddingRight: "4px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #d7d7d7",
                    marginBottom: "20px",
                    overflow: "hidden",
                  }}
                >
                  <TicketEventSummaryHeader ticketEvent={ticketEvent} />

                  <div style={{ padding: "18px 20px 0 20px" }}>
                    <div
                      style={{
                        display: "flex",
                        gap: "20px",
                        alignItems: "flex-start",
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        style={{
                          flex: "1 1 100%",
                          minWidth: 0,
                        }}
                      >
                        <TicketEventDetailsSection ticketEvent={ticketEvent} />

                        <TicketEventActionsSection
                          ticketEvent={ticketEvent}
                          showActions={showActions}
                          reloadData={this.reloadData}
                          redirectPath={redirectPath}
                        />

                        <div
                          style={{
                            display: "flex",
                            gap: "20px",
                            alignItems: "stretch",
                            flexWrap: "wrap",
                          }}
                        >
                          <div
                            style={{
                              flex: "2 1 620px",
                              minWidth: "320px",
                              display: "flex",
                            }}
                          >
                            <TicketEventTicketOptionsSection
                              ticketEvent={ticketEvent}
                            />
                          </div>

                          <div
                            style={{
                              flex: "1 1 280px",
                              minWidth: "260px",
                              maxWidth: "420px",
                              display: "flex",
                            }}
                          >
                            <TicketEventBrandingSection
                              ticketEvent={ticketEvent}
                            />
                          </div>
                        </div>

                        <TicketEventReviewSection ticketEvent={ticketEvent} />
                      </div>
                    </div>
                  </div>

                  <BottomBackBar
                    backLabel="Back"
                    backPath={this.props.backPath}
                    history={this.props.history}
                  />
                </div>
              </div>
            </section>
          );
        })()}
      </BOGraphQLLoader>
    );
  }
}

const withSummaryData = graphql<GqlData, Props>(ticketEventsSummaryQuery, {
  options: () => ({
    fetchPolicy: "network-only",
  }),
});

export default withSummaryData(TicketEventContainer);
